<template>
  <div class="upLoadFileDialog">
    <el-form :model="form" v-if="isUploadAllowed||(!type)">
      <!-- <div class="uploadPicBox">
        <div class="uploadPic">1、主图：800*800像素，建议主图为正面或45度角的图片，最多上传4张；</div>
        <div class="uploadPic">2、详情页：宽度790像素左右，高度不限；</div>
        <div class="uploadPic">3、主图、详情页的图片大小要求单张控制在1M以内，图片质量要清晰，不能虚化；仅支持jpg，jpeg，png格式；</div>
        <div class="uploadPic">4、主图命名规则：按照 【店内码-M1】规则，M1代表主图第一张，M2代表主图第二张，依次类推；</div>
        <div class="uploadPic">5、详情图命名规则：按照 【店内码-D1】规则，D1代表主图第一张，D2代表主图第二张，依次类推。</div>
      </div>-->
      <div class="uploadPicBtn">
        <el-upload
          class="upload-demo"
          ref="upload"
          action="url"
          :on-change="handleChange"
          :auto-upload="false"
          :http-request="customizeUpload"
          :limit="10"
          :on-exceed="exceedNum"
          :on-remove="handleRemove"
          :before-remove="delectFile"
          :file-list="list"
          multiple
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-bottom: 10px;
            "
          >
            <div>
              <el-button size="small" type="primary">点击选择文件</el-button>
              <div slot="tip" class="el-upload__tip">支持单次批量选择10个</div>
              <div class="el-upload__tip">
                上传文件会需要一点时间，请耐心等待
              </div>
            </div>
          </div>
        </el-upload>
        <el-button type="primary" @click="uploadGoodsPic" v-preventReClick
          >确 定</el-button
        >
        <el-button
          v-if="type == 'PROJECT'"
          @click="showDelList"
          v-preventReClick
          >删除记录</el-button
        >
        <div v-if="picNum != 0" class="picNum">{{ picNum }}/10</div>
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="itemVOs"
      border
      size="mini"
      style="width: 100%"
      :file-list="fileList"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumnDatas"
        :key="index"
        :prop="item.class"
        :label="item.labelName"
        :sortable="item.sortEnable"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="downloadFile(scope.$index, scope.row)"
            >下载附件</el-button
          >
          <el-button
            size="mini"
            type="text"
            @click="previewFile(scope.$index, scope.row)"
            >预览</el-button
          >
          <el-button
            size="mini"
            type="text"
            @click="handleDelete(scope.$index, scope.row)"
            v-if="isUploadAllowed||(!type)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--删除记录弹窗-->
    <uploadFileDelRecord ref="uploadFileDelRecord" :itemId="itemId" />
  </div>
</template>
<script>
import {
  insertItemsAfterAudit, //审批通过后，上传总包合同附件
  deleteItemsAfterAudit, //删除审批通过后上传的总包合同附件
  insertProjectAfterAudit, //审批通过后，上传项目附件
  deleteProjectAfterAudit, //删除审批通过后上传的项目附件
  insertSubcontractAfterAudit,
  deleteSubcontractAfterAudit,
  // deleteFileService, //删除文件接口
  uploadFilesService, //上传文件接口
} from "@/services/allContractServices";
import{
  insertMeetingAfterAudit, //会议提报单
  deleteMeetingAfterAudit,
} from "@/services/declarationServices";
import {
  insertPlanAfterAudit,
  deletePlanAfterAudit,
   insertPriceAfterAudit,
    deletePriceAfterAudit,
    insertFileAfterAudit,
    deleteFileAfterAudit,
    insertOrderAfterAudit,
    deleteOrderAfterAudit,
    insertAccountAfterAudit,
    deleteAccountAfterAudit,
} from "@/services/bidServices";
import { previewFile } from "@/utils/index.js";
import uploadFileDelRecord from "@/page/contract/ContractDetail/uploadFileDelRecord.vue";
import {
  exportExcelService2, //导出
  getTempUrlService, //下载附件
} from "@/services/commonService";
export default {
  name: "upLoadFileDialog",
  components: {
    uploadFileDelRecord,
  },
  props: {
    type: {
      type: String,
      default: "",
    },
    itemVOs: {
      type: Array,
    },
    itemId: {
      type: Number,
      default: null,
    },
    approveStatus: {
      type: Number,
      default: null,
    },
    isUploadAllowed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      warnningDialogVisible: false,
      uploadGoodsPicUrl: "",
      hasUnvaildPic: false,
      modelPicVisible: false,
      form: {},
      fileList: new FormData(),
      shopCode: "",
      userCode: "",
      formDate: "",
      list: [],
      chooseList: [],
      failList: [],
      noTypeList: [],
      hasUnvaildType: false,
      unValidTypeNum: 0,
      picNum: 0, //上传列表的图片数量
      openFlag: false,
      currentUser: "", //上传者
      tableColumnDatas: [
        // { class: "id", labelName: "编号", sortEnable: false },
        { class: "name", labelName: "文件名称", sortEnable: false },
        { class: "uploadUserName", labelName: "上传者", sortEnable: false },
        { class: "createTime", labelName: "上传时间", sortEnable: false },
      ],
      uploadFileList: [],
    };
  },

  methods: {
    previewFile,
    //文件状态改变时的钩子
    handleChange(file) {
      this.list.push(file);
      this.uploadFileList.push({
        name: file.name,
      });
      this.picNum = this.list.length;
    },
    //上传之前校验文件名是否重复
    beforeUpload() {
      this.noTypeList = [];
      for (var i = 0; i < this.list.length - 1; i++) {
        for (var j = i + 1; j < this.list.length; j++) {
          if (this.list[i] == this.list[j]) {
            this.noTypeList.push(this.list[i]);
          }
        }
      }
      return this.noTypeList;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    //删除文件
    delectFile(file, fileList) {
      let fileName = file.name;
      let fileIndex = this.list.findIndex((item) => item.name == file.name);
      if (fileIndex != -1) {
        this.list.splice(fileIndex, 1);
        this.uploadFileList.splice(fileIndex, 1);
        this.picNum -= 1;
      }
      // this.list.forEach((item, index) => {
      //   if (item.name == fileName) {
      //     this.list.splice(index, 1);
      //     this.uploadFileList.splice(index, 1);
      //     this.picNum -= 1;
      //     return;
      //   }

      // });
    },
    //自定义上传事件
    customizeUpload(file) {
      this.fileList.append("file", file.file);
    },
    //上传图片至服务器
    uploadGoodsPic() {
      // this.hasUnvaildPic=false;
      if (this.list.length != 0) {
        var validList = this.beforeUpload();
        if (validList.length == 0) {
          this.fileList = new FormData();
          this.$refs.upload.submit();
          uploadFilesService(this.fileList)
            .then((data) => {
              // this.tableColumnDatas=data.data;
              if (data.code == 10000000) {
                let arr = data.data;
                for (let i = 0; i < arr.length; i++) {
                  arr[i].uploadUserName = this.currentUser;
                  arr[i].itemId = this.itemId;
                  arr[i].uploadType = "AFTER_AUDIT";
                  // let date = new Date( "yyyy-MM-dd HH:mm:ss");
                  let date = new Date();
                  arr[i].createTime =
                    date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1) +
                    "-" +
                    date.getDate() +
                    " " +
                    date.getHours() +
                    ":" +
                    date.getMinutes() +
                    ":" +
                    date.getSeconds();
                  this.itemVOs.push(arr[i]);
                }
                this.list = [];
                this.uploadFileList = [];
                this.picNum = 0;
                this.$refs.upload.clearFiles();
                if (this.type) this.uploadAfterAudit(arr);
                else {
                  this.$emit("saveUpdateFile", this.itemVOs);
                  this.$alert("批量上传文件成功", "提示", {
                    confirmButtonText: "确定",
                    type: "success",
                  });
                }
                // if (this.type == "GENERAL_CONTRACT") {
                //   this.uploadItemsAfterAudit(arr);
                // } else if (this.type == "PROJECT") {
                //   this.uploadProjectAfterAudit(arr);
                // }
              } else {
                // this.warnningDialogVisible = true;
                this.$alert(data.msg, "提示", {
                  confirmButtonText: "确定",
                  type: "warning",
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.$alert(error || "系统异常", "提示", {
                confirmButtonText: "确定",
                type: "warning",
              });
            });
        } else {
          this.warnningName();
        }
      } else {
        this.$alert("请选择您要上传的文件", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
      }
    },

    showDelList() {
      // this.$refs.uploadFileDelRecord.showDialog(this.itemId)
      this.$refs.uploadFileDelRecord.showDialog(this.itemId);
    },
    warnningName() {
      this.$alert("您所要上传的文件中有重名,请确认无误后上传", "提示", {
        confirmButtonText: "确定",
        type: "warning",
      });
    },
    //上传图片数量查过限制触发事件
    exceedNum() {
      this.$alert("单次最多选择10个文件", "提示", {
        confirmButtonText: "确定",
        type: "warning",
      });
    },
    //检查文件类型
    checkFileType() {
      this.unValidTypeNum = 0;
      this.list.map((item, index) => {
        var testmsg = item.name.substring(item.name.lastIndexOf(".") + 1);
        if (
          testmsg == "jpeg" ||
          testmsg == "jpg" ||
          testmsg == "png" ||
          testmsg == "doc" ||
          testmsg == "docx" ||
          testmsg == "xls" ||
          testmsg == "xlsx" ||
          testmsg == "pdf" ||
          testmsg == "PDF"
        ) {
          let isLt2M = item.size / 1024 / 1024 < 50;
          if (!isLt2M) {
            this.unValidTypeNum += 1;
          }
        } else {
          this.unValidTypeNum += 1;
        }
      });
      if (this.unValidTypeNum == 0) {
        this.hasUnvaildType = false;
      } else {
        this.hasUnvaildType = true;
      }
    },
    //弹窗关闭后重置上传文件列表
    resetList() {
      this.$refs.upload.clearFiles();
      this.list = [];
      this.picNum = 0;
    },

    //审批通过后，上传附件接口
    uploadAfterAudit(items) {
      let str = [];
      let insertApiName = "";
      if (this.type == "GENERAL_CONTRACT") {
        //总包合同
        str = items.map((item) => {
          return {
            contractId: this.itemId,
            name: item.name,
            resource: item.resource,
          };
        });
        insertApiName = insertItemsAfterAudit;
      } else if (this.type == "PROJECT") {
        //项目
        str = items.map((item) => {
          return {
            projectId: this.itemId,
            name: item.name,
            resource: item.resource,
          };
        });
        insertApiName = insertProjectAfterAudit;
      } else if (this.type == "SUB_CONTRACT") {
        //分项合同
        str = items.map((item) => {
          return {
            contractId: this.itemId,
            name: item.name,
            resource: item.resource,
            subContractItemType: "ITEM",
          };
        });
        insertApiName = insertSubcontractAfterAudit;
      } else if (this.type == "MENTTING") {
        //分项合同会议纪要附件类型
        str = items.map((item) => {
          return {
            contractId: this.itemId,
            name: item.name,
            resource: item.resource,
            subContractItemType: "CONFERENCE",
          };
        });
        insertApiName = insertSubcontractAfterAudit;
      } else if (this.type == "DECLARATION") {  //会议提报单
        //分项合同
        str = items.map((item) => {
          return {
            declarationId: this.itemId,
            name: item.name,
            resource: item.resource,
          };
        });
        insertApiName = insertMeetingAfterAudit;
      } else if (this.type == "BID_PLAN") {
        //采购计划附件类型
        str = items.map((item) => {
          return {
            bidPlanId: this.itemId,
            name: item.name,
            resource: item.resource,
          };
        });
        insertApiName = insertPlanAfterAudit;
      }else if (this.type == "BID_PRICE_CONTROLE") {
        //控制价审核附件类型
        str = items.map((item) => {
          return {
            bidPriceId: this.itemId,
            name: item.name,
            resource: item.resource,
            // subContractItemType: "CONFERENCE",
          };
        });
        insertApiName = insertPriceAfterAudit;
      }else if (this.type == "BID_FILE") {
        //控制价审核附件类型
        str = items.map((item) => {
          return {
            bidFileId: this.itemId,
            name: item.name,
            resource: item.resource,
            // subContractItemType: "CONFERENCE",
          };
        });
        insertApiName = insertFileAfterAudit;
      }else if (this.type == "BID_JOIN_SIGNATURE") {
        //控制价审核附件类型
        str = items.map((item) => {
          return {
            bidSignatureId: this.itemId,
            name: item.name,
            resource: item.resource,
            // subContractItemType: "CONFERENCE",
          };
        });
        insertApiName = insertOrderAfterAudit;
      }else if (this.type == "BID_JOIN_LEDGER") {
        //控制价审核附件类型
        str = items.map((item) => {
          return {
            bidPriceId: this.itemId,
            name: item.name,
            resource: item.resource,
            // subContractItemType: "CONFERENCE",
          };
        });
        insertApiName = insertAccountAfterAudit;
      }
      //审批通过后，上传附件接口
      insertApiName(str)
        .then((res) => {
          if (res.code == 10000000) {
            this.$message.success("上传完成");
            this.$emit("saveUpdateFile", this.itemVOs);
          } else {
            this.$alert(res.msg, "错误", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "错误", {
            confirmButtonText: "确定",
          });
        });
    },
    //删除附件中的某一行
    handleDelete(index, row) {
      console.log(index, row);
      this.$confirm("确定要删除此附件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (!this.type){
            this.itemVOs.splice(index, 1);
            this.$emit("saveUpdateFile", this.itemVOs);  
            return          
          }
          //删除附件接口 20221220
          let param = {
            id: row.id,
          };
          let apiName = "";
          if (this.type == "GENERAL_CONTRACT") {
            //总包合同
            param.contractId = this.itemId;
            apiName = deleteItemsAfterAudit;
          } else if (this.type == "PROJECT") {
            //项目
            param.projectId = this.itemId;
            apiName = deleteProjectAfterAudit;
          } else if (this.type == "SUB_CONTRACT") {
            //分项合同
            param.contractId = this.itemId;
            param.subContractItemType = "ITEM";
            apiName = deleteSubcontractAfterAudit;
          } else if (this.type == "MENTTING") {
            //分项合同会议纪要附件类型
            param.contractId =this.itemId;
            param.subContractItemType = "CONFERENCE";
            apiName = deleteSubcontractAfterAudit;
          } else if (this.type == "DECLARATION") {
            //会议提报单
            param.declarationId = this.itemId;
            apiName = deleteMeetingAfterAudit;
          } else if (this.type == "BID_PLAN") {
            //采购计划
            param.attachmentId = row.id;
            apiName = deletePlanAfterAudit;
          }else if (this.type == "BID_PRICE_CONTROLE") {
            //控制价
            param.attachmentId = row.id;
            apiName = deletePriceAfterAudit;
          }else if (this.type == "BID_FILE") {
            //采购文件
            param.attachmentId = row.id;
            apiName = deleteFileAfterAudit;
          }else if (this.type == "BID_JOIN_SIGNATURE") {
            //审签单
            param.attachmentId = row.id;
            apiName = deleteOrderAfterAudit;
          }else if (this.type == "BID_JOIN_LEDGER") {
            //采购台账
            param.attachmentId = row.id;
            apiName = deleteAccountAfterAudit;
          }
          apiName(param)
            .then((res) => {
              if (res.code == 10000000) {
                this.$message.success("删除成功");
                this.itemVOs.splice(index, 1);
                this.$emit("saveUpdateFile", this.itemVOs);
              } else {
                this.$message.warning(res.msg);
              }
            })
            .catch((error) => {
              this.$message.error("系统异常");
            });
        })
        .catch((error) => {});
    },
    downloadFile(index, row) {
      let reqParam = {
        filePath: row.resource,
        fileName: row.name,
      };
      getTempUrlService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            //下载附件
            exportExcelService2(res.data.renameUrl).then((res1) => {
              this.$alert("下载成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //文件预览
    // previewFile(index, row) {
    //   let reqParam = {
    //     filePath: row.resource,
    //   };
    //   getPreviewUrlService(reqParam).then(
    //     (res) => {
    //       if (res.code == 10000000) {
    //         let filePath = res.data;
    //         // let typeLast =
    //         //   filePath.indexOf("?") > 0
    //         //     ? filePath.indexOf("?")
    //         //     : filePath.length;
    //         //     let type = filePath.substring(
    //         //             filePath.lastIndexOf(".") + 1,
    //         //             typeLast
    //         //         ); //文件类型
    //         if (
    //           row.name.indexOf("doc") != -1 ||
    //           row.name.indexOf("docx") != -1 ||
    //           row.name.indexOf("xsl") != -1 ||
    //           row.name.indexOf("xslx") != -1 ||
    //           row.name.indexOf("xlsx") != -1||
    //           row.name.indexOf("pdf") != -1 ||
    //           row.name.indexOf("jpg") != -1 ||
    //           row.name.indexOf("png") != -1 ||
    //           row.name.indexOf("jpeg") != -1
    //         ) {
    //           // billNoStr.push(res.data);
    //           let routeData = this.$router.resolve({
    //             path: "/overviewFile",
    //             query: { filePath: filePath,fileName: row.name},
    //           });
    //           window.open(routeData.href, "_blank");
    //         } else {
    //           this.$alert("当前文件类型暂不支持预览", "提示", {
    //             confirmButtonText: "确定",
    //           });
    //         }
    //       } else {
    //         this.$alert(res.msg, "提示", {
    //           confirmButtonText: "确定",
    //         });
    //       }
    //     },
    //     (err) => {
    //       this.$alert("系统异常", "提示", {
    //         confirmButtonText: "确定",
    //       });
    //     }
    //   );

    //   // window.open(row.resource, "_blank");
    //   // window.location.href = row.url;
    // },
  },
  mounted() {
    this.currentUser = sessionStorage.getItem("name");
  },
};
</script>
<style lang="scss" scoped>
.upLoadFileDialog {
  margin-top: 16px;
}
.uploadPicBox {
  font-size: 15px;
  line-height: 25px;
  margin: 0 10px;
  text-align: left;
  color: #000000;
}
.uploadPicBtn {
  margin: 0 10px 10px;
  text-align: left;
  .picNum {
    margin-top: 10px;
    font-size: 14px;
    margin-left: 5px;
  }
}
.modelPicTxt {
  font-size: 16px;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  margin-left: 35px;
}
.modelTit {
  font-size: 16px;
  font-weight: 600;
  color: black;
  margin-top: 20px;
  margin-left: 35px;
  margin-bottom: 10px;
}
.modelPicList {
  display: flex;
  justify-content: flex-start;
  margin-left: 35px;
  div {
    width: 174px;
    font-size: 15px;
    color: #000000;
  }
  .modelBox {
    margin-right: 20px;
    border: 1px solid #d3d3d3;
  }
  .modelTip {
    padding: 4px;
    font-weight: 400;
    line-height: 23px;
    width: auto;
    color: #000;
  }
}
.showFailListTit {
  font-size: 17px;
  text-align: center;
  color: royalblue;
}
.showFailList {
  font-size: 15px;
  line-height: 25px;
  margin: 10px 20px;
}
.el-dialog__title {
  font-weight: 500;
}
/deep/.el-menu--horizontal.el-popover {
  margin-top: -17px !important;
}
/deep/.el-upload {
  display: block !important;
  text-align: left !important;
}
/deep/.el-upload-list {
  max-height: 300px;
  overflow: auto;
  box-shadow: 0 0 10px 0 rgba(204, 204, 204, 0.5);
}
/deep/.el-dialog__body {
  padding: 10px 20px !important;
}
/deep/.el-icon-close::before {
  color: #333333;
}
</style>
